export const isIos = () => {
  if (typeof navigator === 'undefined') {
    return false
  }

  const userAgent = navigator.userAgent || ''
  if (/iphone|ipad|ipod/i.test(userAgent)) {
    return true
  }

  const platform = navigator.platform || ''
  const hasTouch =
    typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1

  return /macintel/i.test(platform) && hasTouch
}
